export interface ManagementTableColumn {
  headerName: string;
  variant: ManagementTableColumns;
}

export enum ManagementTableColumns {
  NAME = "customer-name",
  ADDRESS_LINE = "address-line",
  ADDRESS = "address",
  TOTAL_ORDERS_COUNT = "total-orders-count",
  NUMBER_OF_PARCELS = "number-of-parcels",
  TOTAL_WEIGHT = "total-weight",
  TOTAL_PAYMENTS = "total-payments",
  BALANCE = "balance",
  EMAIL = "email",
  REGISTERED_DATE = "registered-date",
  USER_STATUS = "user-status",
  MOBILE_ORDER_STATUS = "order-mobile-status",
  ACTIONS = "actions",
  ORDER_ACTIONS = "order_actions",
  WAREHOUSE = "warehouse",
  CITY = "city",
  STATE = "state",
  ZIP_CODE = "zip-code",
  USER_PHONE = "user-phone",
  WAREHOUSE_NAME = "warehouseName",
  WAREHOUSE_CITY = "warehouseCity",
  WAREHOUSE_COUNTRY = "warehouseCountry",
  WAREHOUSE_ADDRESS = "warehouseAddress",
  WAREHOUSE_PHONE = "warehousePhone",

  MESSAGE_KEY = "messageKey",
  MESSAGE_NAME = "messageName",
  MESSAGE_SECTION = "messageSection",

  STATIC_DATA_NAME = "staticDataName",
  STATIC_DATA_TITLE = "staticDataTitle",
  STATIC_DATA_JSON_NAME = "staticDataJsonName",
  PRODUCT_CATEGORY_DESCRIPTION = "productCategoryDescription",
  STORE_STATUS = "status",
  PROVINCE_COUNTRY = "provinceCountry",
  CITY_PROVINCE = "cityProvince",
  REGION_CITY = "regionCity",
}

export const nameColumn: ManagementTableColumn = {
  headerName: "name",
  variant: ManagementTableColumns.NAME,
};
export const addressLine2Column: ManagementTableColumn = {
  headerName: "address_line2",
  variant: ManagementTableColumns.ADDRESS_LINE,
};
export const addressColumn: ManagementTableColumn = {
  headerName: "address",
  variant: ManagementTableColumns.ADDRESS,
};
export const totalCountColumn: ManagementTableColumn = {
  headerName: "total_count",
  variant: ManagementTableColumns.TOTAL_ORDERS_COUNT,
};
export const numberOfParcelsColumn: ManagementTableColumn = {
  headerName: "number_of_parcels",
  variant: ManagementTableColumns.NUMBER_OF_PARCELS,
};
export const totalWeightColumn: ManagementTableColumn = {
  headerName: "total_weight",
  variant: ManagementTableColumns.TOTAL_WEIGHT,
};
export const totalPaymentsColumn: ManagementTableColumn = {
  headerName: "total_payments",
  variant: ManagementTableColumns.TOTAL_PAYMENTS,
};
export const balanceColumn: ManagementTableColumn = {
  headerName: "balance",
  variant: ManagementTableColumns.BALANCE,
};
export const emailColumn: ManagementTableColumn = {
  headerName: "email",
  variant: ManagementTableColumns.EMAIL,
};
export const userPhoneColumn: ManagementTableColumn = {
  headerName: "user_phone",
  variant: ManagementTableColumns.USER_PHONE,
};
export const registeredDateColumn: ManagementTableColumn = {
  headerName: "registered_date",
  variant: ManagementTableColumns.REGISTERED_DATE,
};
  export const userStatusColumn: ManagementTableColumn = {
    headerName: "user_status",
    variant: ManagementTableColumns.USER_STATUS,
  };
export const orderMobileStatusColumn: ManagementTableColumn = {
  headerName: "order_status",
  variant: ManagementTableColumns.MOBILE_ORDER_STATUS,
};
export const actionsColumn: ManagementTableColumn = {
  headerName: "actions",
  variant: ManagementTableColumns.ACTIONS,
};
export const orderActionsColumn: ManagementTableColumn = {
  headerName: "order_actions",
  variant: ManagementTableColumns.ORDER_ACTIONS,
};
export const warehouseColumn: ManagementTableColumn = {
  headerName: "warehouse_address",
  variant: ManagementTableColumns.WAREHOUSE,
};
export const cityColumn: ManagementTableColumn = {
  headerName: "city",
  variant: ManagementTableColumns.CITY,
};
export const zipCodeColumn: ManagementTableColumn = {
  headerName: "zip-code",
  variant: ManagementTableColumns.ZIP_CODE,
};
export const stateColumn: ManagementTableColumn = {
  headerName: "state",
  variant: ManagementTableColumns.STATE,
};
export const warehouseName: ManagementTableColumn = {
  headerName: "warehouse_name",
  variant: ManagementTableColumns.WAREHOUSE_NAME,
};
export const warehouseCity: ManagementTableColumn = {
  headerName: "warehouse_city",
  variant: ManagementTableColumns.WAREHOUSE_CITY,
};
export const warehouseCountry: ManagementTableColumn = {
  headerName: "warehouse_country",
  variant: ManagementTableColumns.WAREHOUSE_COUNTRY,
};
export const warehouseAddress: ManagementTableColumn = {
  headerName: "warehouse_address",
  variant: ManagementTableColumns.WAREHOUSE_ADDRESS,
};
export const warehousePhone: ManagementTableColumn = {
  headerName: "warehouse_phone",
  variant: ManagementTableColumns.WAREHOUSE_PHONE,
};

export const messageKey: ManagementTableColumn = {
  headerName: "message_key",
  variant: ManagementTableColumns.MESSAGE_KEY,
};
export const messageName: ManagementTableColumn = {
  headerName: "message_name",
  variant: ManagementTableColumns.MESSAGE_NAME,
};
export const messageSection: ManagementTableColumn = {
  headerName: "message_section",
  variant: ManagementTableColumns.MESSAGE_SECTION,
};

export const staticDataNameColumn: ManagementTableColumn = {
  headerName: "name",
  variant: ManagementTableColumns.STATIC_DATA_NAME,
};
export const staticDataTitleColumn: ManagementTableColumn = {
  headerName: "title",
  variant: ManagementTableColumns.STATIC_DATA_TITLE
};
export const staticDataJsonNameColumn: ManagementTableColumn = {
  headerName: "name",
  variant: ManagementTableColumns.STATIC_DATA_JSON_NAME,
};
export const productCategoryDescriptionColumn: ManagementTableColumn = {
  headerName: "description",
  variant: ManagementTableColumns.PRODUCT_CATEGORY_DESCRIPTION,
};
export const storesStatusColumn: ManagementTableColumn = {
  headerName: "status",
  variant: ManagementTableColumns.STORE_STATUS,
};
export const provinceCountry: ManagementTableColumn = {
  headerName: "country",
  variant: ManagementTableColumns.PROVINCE_COUNTRY,
};
export const cityProvince: ManagementTableColumn = {
  headerName: "province",
  variant: ManagementTableColumns.CITY_PROVINCE,
};
export const regionCity: ManagementTableColumn = {
  headerName: "city",
  variant: ManagementTableColumns.REGION_CITY,
};
